// extracted by mini-css-extract-plugin
module.exports = {"container":"PickupAssigned_container__aMoNr","box":"PickupAssigned_box__4C53A","backIcon":"PickupAssigned_backIcon__9cQqA","textContainer":"PickupAssigned_textContainer__jNpZk"};